<div class="loading-shade" *ngIf="isLoading">
  <mat-spinner *ngIf="isLoading"></mat-spinner>
</div>

<div class="top">
  <h2>Esquema de Cabezal</h2>
</div>

<div class="scheme-cards">
  <div class="scheme-card" *ngFor="let scheme of schemes; let i = index">
    <button mat-icon-button class="remove" title="Eliminar" *ngIf="!readOnlyContent"
      (click)="removeScheme(i)">
      <mat-icon class="material-icons-outlined">close</mat-icon>
    </button>

    <mat-label>Sección</mat-label>
    <mat-form-field>
      <mat-select name="sectionId" [(ngModel)]="schemes[i].sectionId"
        (selectionChange)="enableSaveButton()" [disabled]="readOnlyContent"
        placeholder="Seleccionar">
        <mat-option *ngFor="let section of sections" [value]="section.sectionId">
          {{section.sectionName}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-label>Presión de trabajo</mat-label>
    <mat-form-field>
      <input matInput inputmode="numeric" name="workingPressure"
        [(ngModel)]="schemes[i].workingPressure" (change)="enableSaveButton()"
        [disabled]="readOnlyContent" digitOnly [decimal]="true"
        pattern="^\d+(\.\d{1,2})?$" [min]="0" />
      <mat-hint class="unit">psi</mat-hint>
    </mat-form-field>

    <mat-label>Fecha de prueba</mat-label>
    <mat-form-field>
      <input matInput [matDatepicker]="testDate" name="testDate"
        [(ngModel)]="schemes[i].testDate" [readonly]="readOnlyContent"
        [disabled]="readOnlyContent" (dateChange)="enableSaveButton()" />
      <mat-datepicker-toggle matSuffix [disabled]="readOnlyContent"
        [for]="testDate"></mat-datepicker-toggle>
      <mat-datepicker #testDate></mat-datepicker>
    </mat-form-field>
  </div>

  <button class="add-card" *ngIf="!readOnlyContent" (click)="addScheme()">
    <mat-icon class="material-icons-outlined">add</mat-icon>
    <span>Agregar sección</span>
  </button>
</div>

<div class="scheme-actions">
  <button mat-button class="save" title="Guardar" (click)="save()"
    [disabled]="isDisabled || readOnlyContent">
    <mat-icon class="material-icons-outlined">save</mat-icon>Guardar
  </button>
</div>
